import { render, staticRenderFns } from "./MemberNotificationSettings.vue?vue&type=template&id=75665a69&scoped=true&lang=pug&"
import script from "./MemberNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./MemberNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./MemberNotificationSettings.vue?vue&type=style&index=0&id=75665a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75665a69",
  null
  
)

export default component.exports